"use strict";

require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MapContent = void 0;
require("core-js/modules/es.number.to-fixed.js");
var _react = _interopRequireWildcard(require("react"));
var _reactMapGl = require("react-map-gl");
var _reactRedux = require("react-redux");
var _MapContentModule = _interopRequireDefault(require("../../styles/components/Map/MapContent.module.css"));
var _actions = require("../../redux/actions");
var _selectors = require("../../redux/selectors");
var _layers = require("./layers");
var _SiteCard = require("../MapPanel/SiteCard");
var _paulCorePackage = require("paul-core-package");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
const MapContent = /*#__PURE__*/(0, _react.forwardRef)((_ref, mapRef) => {
  var _activeCard$coordinat, _activeCard$coordinat2;
  let {
    nameForm,
    showCompass
  } = _ref;
  const {
    current: map
  } = mapRef || {};
  const dispatch = (0, _reactRedux.useDispatch)();
  const activeSite = (0, _reactRedux.useSelector)(_selectors.selectActiveSiteId);
  const filteredData = (0, _reactRedux.useSelector)(_selectors.getFilteredData);
  const sites = filteredData[nameForm] || [];
  const tV = (0, _paulCorePackage.useTranslationValue)();
  const hasDiff12 = function hasDiff12() {
    let a1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let a2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a1.find(i1 => !a2.find(i2 => i2.toFixed(12) === i1.toFixed(12)));
  };
  const goToPoint = (0, _react.useCallback)(function () {
    var _point$geometry;
    let point = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    const {
      current: m
    } = mapRef || {};
    const mapCenter = Object.values(m === null || m === void 0 ? void 0 : m.getCenter());
    if (point !== null && point !== void 0 && (_point$geometry = point.geometry) !== null && _point$geometry !== void 0 && _point$geometry.coordinates && hasDiff12(point.geometry.coordinates, mapCenter)) {
      m.flyTo({
        center: point.geometry.coordinates,
        pitch: m.getPitch() !== 70 ? 0 : 70,
        zoom: m.getZoom() < 11.5 ? 11.5 : m.getZoom(),
        essential: true
      });
    }
  }, [mapRef]);
  const clickOnMarker = (0, _react.useCallback)(point => {
    const {
      id
    } = point.properties;
    if (activeSite !== id) {
      goToPoint(point);
      dispatch((0, _actions.setActiveSite)(id));
    } else {
      goToPoint();
      dispatch((0, _actions.setActiveSite)(null));
    }
  }, [activeSite, dispatch, goToPoint]);
  let timeout;
  const openSite = (0, _react.useCallback)(_ref2 => {
    let {
      siteId
    } = _ref2;
    const mapCenter = Object.values(map.getCenter());
    const point = sites.find(point => point.id === siteId);
    const {
      latitude,
      longitude
    } = (point === null || point === void 0 ? void 0 : point.coordinates) || {};
    const hasDiff = latitude && longitude ? hasDiff12([longitude, latitude], mapCenter) : false;
    if (hasDiff) {
      map.flyTo({
        center: [longitude, latitude],
        essential: true
      });
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        dispatch((0, _actions.setHasZoom)(true));
        map.flyTo({
          zoom: 16.69,
          essential: true
        });
      }, 800);
    } else {
      dispatch((0, _actions.setHasZoom)(true));
      map.flyTo({
        zoom: 16.69,
        essential: true
      });
    }
  }, [sites, map, dispatch]);
  const mapPointers = sites.map(point => {
    var _point$coordinates, _point$coordinates2;
    return {
      type: 'Feature',
      properties: _objectSpread(_objectSpread({}, point), {}, {
        lat: (_point$coordinates = point.coordinates) === null || _point$coordinates === void 0 ? void 0 : _point$coordinates.latitude,
        long: (_point$coordinates2 = point.coordinates) === null || _point$coordinates2 === void 0 ? void 0 : _point$coordinates2.longitude,
        street: tV(point.street)
      }),
      geometry: {
        type: 'Point',
        coordinates: [point.coordinates.longitude, point.coordinates.latitude]
      }
    };
  });
  (0, _react.useEffect)(() => {
    const {
      current: m
    } = mapRef || {};
    m === null || m === void 0 ? void 0 : m.on('click', 'marker', e => {
      if (e.features[0]) {
        clickOnMarker(e.features[0]);
      }
    });
  }, [mapRef, clickOnMarker]);
  const activeCard = sites.find(s => s.id === activeSite);
  (0, _react.useEffect)(() => {
    if (activeCard && map) {
      if ((map === null || map === void 0 ? void 0 : map.getPitch()) !== 70) map === null || map === void 0 ? void 0 : map.setPitch(0);
      const {
        latitude,
        longitude
      } = (activeCard === null || activeCard === void 0 ? void 0 : activeCard.coordinates) || {};
      if (latitude && longitude) {
        map === null || map === void 0 ? void 0 : map.flyTo({
          center: [longitude, latitude],
          essential: true,
          speed: 1
        });
      }
    }
  }, [map, activeCard]);
  const getIndex = point => sites.findIndex(card => card.id === point.id);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactMapGl.Source, {
    id: "cluster-source",
    type: "geojson",
    generateId: true,
    data: {
      type: 'FeatureCollection',
      features: mapPointers || []
    },
    cluster: true,
    clusterMaxZoom: 14,
    clusterRadius: 50
  }, /*#__PURE__*/_react.default.createElement(_reactMapGl.Layer, _layers.unclusteredPointLayer), /*#__PURE__*/_react.default.createElement(_reactMapGl.Layer, _layers.clusterLayer), /*#__PURE__*/_react.default.createElement(_reactMapGl.Layer, _layers.clusterCountLayer)), activeCard && /*#__PURE__*/_react.default.createElement(_reactMapGl.Popup, {
    tipSize: 5,
    longitude: (_activeCard$coordinat = activeCard.coordinates) === null || _activeCard$coordinat === void 0 ? void 0 : _activeCard$coordinat.longitude,
    latitude: (_activeCard$coordinat2 = activeCard.coordinates) === null || _activeCard$coordinat2 === void 0 ? void 0 : _activeCard$coordinat2.latitude,
    className: "".concat(_MapContentModule.default.popup),
    anchor: "bottom",
    closeButton: false,
    offset: {
      bottom: [0, -55]
    }
  }, /*#__PURE__*/_react.default.createElement(_SiteCard.SiteCard, {
    card: activeCard,
    index: getIndex(activeCard),
    isForMap: true,
    show: activeSite === activeCard.id,
    goTo: openSite
  })), /*#__PURE__*/_react.default.createElement(_reactMapGl.NavigationControl, null));
});
exports.MapContent = MapContent;